import {customElement, property} from 'lit/decorators.js';
import {style as toggleStyles} from './toggle.styles';
import {html, nothing, LitElement} from 'lit';
import {FormControlDependencyMixin} from "@/components/form-control-dependency/form-control-dependency-mixin";
import {FormValidationMixin} from "@/components/mixins/form-validation-mixin";

@customElement('sbk-toggle')
export class SbkToggle extends FormControlDependencyMixin(FormValidationMixin(LitElement)) {

    static formAssociated = true;

    _internals: ElementInternals;

    @property({type: Boolean, reflect: true})
    checked = false;

    @property({type: Boolean, reflect: true})
    disabled = false;

    @property({type: Boolean})
    labelRight = false;

    @property()
    label = '';

    @property()
    name: string = ''

    @property()
    value: string = ''

    @property()
    toggleTextTrue: string = 'Ja'

    @property()
    toggleTextFalse: string = 'Nein'

    @property()
    variant: 'full' | '' = ''

    constructor() {
        super();
        this._internals = this.attachInternals();
        this._onChange = this._onChange.bind(this);
        this.addEventListener('form-control-dependency-show', () => {
            this.show();
        });
        this.addEventListener('form-control-dependency-hide', () => {
            this.hide();
        });
    }

    connectedCallback() {
        super.connectedCallback();
    }

    static get styles() {
        return [
            toggleStyles,
        ];
    }

    private _onChange() {
        if (!this.disabled) {
            this.checked = !this.checked;
            this._internals.setFormValue(this.checked ? 'true' : '');
            this.dispatchEvent(new CustomEvent('toggle-change', {
                detail: {enabled: this.checked},
                bubbles: true,
                composed: true
            }));
        }
    }

    render() {
        const togglePositionClass = this.checked ? 'toggle-right' : 'toggle-left';
        const labelPositionClass = this.labelRight ? 'label-right' : 'label-left';

        return html`
            <div class="switch-toggle__wrapper">
                <label class="toggle__label">
                    <input
                            type="checkbox"
                            name=${this.name}
                            .value=${this.value}
                            class="sr-only switch-toggle"
                            ?checked=${this.checked}
                            ?disabled=${this.disabled}
                            @change=${this._onChange}
                    >
                    <span class="toggle__wrapper ${labelPositionClass} ${this.variant}">
                        <span class="toggle ${togglePositionClass}">
                            ${this.checked ? `${this.toggleTextTrue}` : `${this.toggleTextFalse}`}
                        </span>
                        ${this.label ? html`<span
                                class="toggle__label-text">
                            ${this.label}
                        </span>` : nothing}
                    </span>
                </label>
            </div>
        `;
    }

    hide(): void {
        this.hidden = true;
    }

    show(): void {
        this.hidden = false;
    }
}
